import { Component, Input, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable, of, Subject, takeUntil } from 'rxjs';
import { UploadPhotoModel } from 'src/app/models/upload-photo-model';
import { StoreLocationLogoComponentStore } from 'src/app/stores/components/store-location-logo/store-location-logo.component-store';
import * as _ from 'lodash';
import { StoreLocationModel } from 'src/app/models/store-location-model';

@Component({
    selector: 'app-store-location-logo',
    templateUrl: './store-location-logo.component.html',
    styleUrls: ['./store-location-logo.component.scss'],
    standalone: false
})
export class StoreLocationLogoComponent implements OnInit {
  readonly max_size = 538 * 1024;
  readonly allowed_types = ['image/png', 'image/jpeg'];
  readonly max_height = 512;
  readonly max_width = 512;
  readonly placeholderUrl = '/assets/img/placeholder.png';

  @Input()
  storeLocation : StoreLocationModel;

  ngUnsubscribeState = new Subject<void>();

  isImageSaved: boolean;

  storeLocationLogoUrl$: Observable<string>;

  constructor(private storeLocationLogoComponentStore: StoreLocationLogoComponentStore,
    private snackBar: MatSnackBar
  ) {
    // Do nothing
  }

  ngOnInit(): void {
    this.storeLocationLogoComponentStore.logo$.pipe(takeUntil(this.ngUnsubscribeState)).subscribe(logo => {
      if (logo !== null && logo !== undefined) {
        this.isImageSaved = true;
        this.storeLocationLogoUrl$ = of(logo.url);
      }
      else {
        this.isImageSaved = false;
        this.storeLocationLogoUrl$ = of(this.placeholderUrl);
      }
    });
  }

  ngOnDestroy() {
    this.ngUnsubscribeState.next();
    this.ngUnsubscribeState.complete();
  }

  ngOnChanges(changes){
    if(!changes.storeLocation.firstChange){
      
      this.storeLocationLogoComponentStore.getStoreLocationLogo({ companyId: this.storeLocation.company.id, storeLocationId: this.storeLocation.id });      
    }
  }

  fileChangeEvent(fileInput: any) {
    if (fileInput.target.files && fileInput.target.files[0]) {
      if (fileInput.target.files[0].size > this.max_size) {
        var errorMessage =
          'Maximum size allowed is ' + Math.floor(this.max_size / 1000) + 'Kb';
        this.snackBar.open(errorMessage, "Dismiss");
        return false;
      }

      if (!_.includes(this.allowed_types, fileInput.target.files[0].type)) {
        var errorMessage = 'Only Images are allowed ( JPG | PNG )';
        this.snackBar.open(errorMessage, "Dismiss");
        return false;
      }

      var uploadPhoto = new UploadPhotoModel();

      const reader = new FileReader();
      reader.onload = (e: any) => {
        const image = new Image();
        image.src = e.target.result;
        image.onload = rs => {
          const img_height = rs.currentTarget['height'];
          const img_width = rs.currentTarget['width'];
          if (img_height > this.max_height && img_width > this.max_width) {
            var errorMessage =
              'Maximum dimensions allowed ' +
              this.max_height +
              '*' +
              this.max_width +
              'px';
            this.snackBar.open(errorMessage, "Dismiss");
            return false;
          } else {
            const imgBase64Path = e.target.result;
            uploadPhoto.fileContentBase64 = imgBase64Path.split(',')[1];
            this.storeLocationLogoComponentStore.uploadStoreLocationLogo({ companyId: this.storeLocation.company.id, storeLocationId: this.storeLocation.id, uploadPhoto: uploadPhoto });

            return true;
          }
        };
      };

      var logo = fileInput.target.files[0];

      uploadPhoto.title = 'Store Location Logo';
      uploadPhoto.fileName = 'logo' + this._determineFileExtension(logo.type);

      reader.readAsDataURL(logo);
      return true;
    }
    return true;
  }

  removeImage() {
    this.storeLocationLogoComponentStore.deleteStoreLocationLogo({ companyId: this.storeLocation.company.id, storeLocationId: this.storeLocation.id });
  }

  _determineFileExtension(fileType: string): string {
    switch (fileType) {
      case 'image/jpg':
      case 'image/jpeg':
        return '.jpg';
      case 'image/png':
        return '.png';
    }
    throw new Error('Unsupported file type:' + fileType);
  }
}
